// 確定 op（committed へ実際に畳み込んだ op）に対応する一時プレビュー（ゴースト）を破棄する共有ヘルパー。
// onServerCommit / loadSnapshot が「committed 化した op」を返す契約になっているため、その返り値に対して
// 呼び出し側でこれを呼ぶ。WebSocket 経路（use-realtime-connection）と REST bootstrap 経路
// （use-canvas-bootstrap）の双方から使い、経路差で transient ゴーストの破棄漏れ（二重表示）が出ないようにする。
// - transform: 確定させた本人のゴーストのみ破棄（別ユーザーが同じオブジェクトを操作中の
//   新しいゴーストを誤って消さない）
// - delete: オブジェクト自体が消えるため、誰のゴースト（変形プレビュー・テキスト編集カーソル）でも破棄
// - create: 採番済みオブジェクトの id でゴースト枠を破棄
// - pen.stroke.commit: 確定ストロークの id（=描画中 strokeId）のゴーストのみ破棄
// テキスト編集カーソル（object.text.cursor transient）は object.text.update の確定では破棄しない
//   （編集は継続中で、消すと次のカーソル配信まで明滅するため）。オブジェクト削除でのみ即時破棄する。
import type { CanvasOp } from "@refinement-canvas/domain";
import { useCanvasTransientStore } from "./store/canvas-transient-store";

export function clearTransientForCommittedOp(op: CanvasOp): void {
  const transient = useCanvasTransientStore.getState();
  switch (op.type) {
    case "object.transform":
      transient.clearTransformsForObject(op.objectId, op.actorUserId);
      return;
    case "object.delete":
      transient.clearTransformsForObject(op.objectId);
      // 削除されたオブジェクトに残る他参加者のテキスト編集カーソルも即時に破棄する
      // （消えたオブジェクト上にカーソルが最長 STALE_MS 残る不整合を防ぐ）。
      transient.clearTextCaretsForObject(op.objectId);
      return;
    case "object.create":
      transient.clearTransformsForObject(op.object.id);
      return;
    case "pen.stroke.commit":
      // 確定オブジェクト ID は描画中 strokeId と一致するため、該当ストロークだけを破棄する。
      transient.clearPenStroke(op.object.id);
      return;
    default:
      return;
  }
}
